import type { SelectOption } from './useMultiBuildingServiceRequestFilterAttributes';

export type DeduplicatedOption = { name: string; ids: string[] };

export function deduplicateSelectOptions(options: SelectOption[]): DeduplicatedOption[] {
  const byName = new Map<string, string[]>();

  for (const { name, id } of options) {
    if (!byName.has(name)) byName.set(name, []);
    byName.get(name)!.push(id);
  }

  return Array.from(byName.entries()).map(([name, ids]) => ({ name, ids }));
}

export function findDeduplicatedValue(
  deduped: DeduplicatedOption[],
  selectedIds: string[] | undefined
): string | null {
  if (!selectedIds?.length) return null;

  const set = new Set(selectedIds);

  return deduped.find(opt => opt.ids.some(id => set.has(id)))?.name ?? null;
}
